import React from 'react';
import RetainershipForm from '../component/Retainership/retainership';
import { socialData } from '../data/socialData';

export default function Retainership() {
  return (
    <div className=" min-h-screen mt-[10%] flex md:flex-row flex-col md:items-start items-center justify-center py-12 px-6">
      <div className="max-w-4xl bg-white p-8 text-start ">
        <h1 className="text-4xl  text-start font-bold  text-[#CFAF5A] mb-6">Retainership Program</h1>
        
        <p className="text-gray-800  text-start text-lg mb-6 ">
          Anil Dhyani & Associates has always welcomed talents with exceptional skills and passion for the law. With our diverse practices, individuals can grow and contribute significantly toward achieving a common goal.
        </p>
        
        <p className="text-gray-800  text-start text-lg mb-6 ">
          We have cultivated a culture where everyone is treated equally. Diversity, inclusiveness, and creativity empower our attorneys to work collaboratively and foster excellence and professionalism.
        </p>
        
        <div className="bg-[#0F172A] p-6 rounded-lg shadow-md text-center text-white">
          <h2 className="text-2xl  text-[#CFAF5A] text-start font-semibold mb-4">How to Apply?</h2>
          <p className="text-lg  text-start">
            To apply, please send us an email with your name, PQE, and location in the subject line along with your CV at <span className="font-semibold">{socialData.mail}</span> or fill in the adjacent form.
          </p>
        </div>
      </div>
      
      <div className="mt-8 w-full max-w-4xl">
        <RetainershipForm />
      </div>
    </div>
  );
}